const categoryEdit = resolve => require(["@/pages/categoryEdit/index.vue"], resolve);
const category = resolve => require(["@/pages/categoryShow/index.vue"], resolve);
const router = [{
    path: '/categoryEdit',
    component: categoryEdit,
}, {
    path: "/category",
    component: category,
}];

export default router;
